var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"bg-dark clear"},[_c('div',{staticClass:"logo fl",attrs:{"href":"http://mnbinggui.mengniu.com.cn/web/index.htm"}},[_vm._v("智能卧式柜监测云平台")]),_vm._v(" "),_c('div',{staticClass:"fr"})])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2118ba9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/cHeader.vue
// module id = null
// module chunks = 